import { ReactElement } from "react";
import disclaimerDots from "../../../assets/images/disclaimer/dots.png";
import disclaimerWatermark from "../../../assets/images/disclaimer/watermark.png";

interface PrivacyPolicySection {
  heading: string;
  paragraphs: string[];
}

const PRIVACY_POLICY_SECTIONS: PrivacyPolicySection[] = [
  {
    heading: "How we may share the Data we collect",
    paragraphs: [
      "Only the people who need to process the Data have access to your Data.",
      "We may need to allow our suppliers and sub-suppliers access to your personal data when they perform services on our behalf, mainly to maintain and support our IT systems.",
    ],
  },
  {
    heading: "How long we will keep your Data",
    paragraphs: [
      "Your Data will be retained for the specified purposes mentioned above only for so long as you are a business contact of ours. As mentioned, every time that we email you, you will have the opportunity to unsubscribe if you no longer wish to receive communications and invitations from us, clicking the unsubscribe link on the bottom of each email.",
    ],
  },
  {
    heading: "Security measures to keep your Data safe",
    paragraphs: [
      "We adopt appropriate technical and organizational security measures to protect your Data against loss and to guard against access by unauthorized persons, such measures including the implementation of secure private connections (VPN connections). Security measures and procedures are regularly reviewed to ensure our systems and Data processed are secure and protected on an ongoing basis.",
    ],
  },
  {
    heading: "Your choices and rights",
    paragraphs: [
      "We welcome your enquiries and comments. You have the right to know what Data we process about you and you may request a copy. You are also entitled to have incorrect Data about you corrected and you may in some cases ask us to delete your Data altogether.",
      "You can also object to certain Data about you being processed and request that processing of your Data be limited. Please note that one consequence of the limitation or deletion of your Data may mean we will be unable to provide the communications and invitations described above. In specific cases, you also have the right to receive your Data in a machine-readable format and have the Data transferred to another party responsible for data processing.",
    ],
  },
];

const CONTACT_EMAIL = "privacy@worldservicesgroup.com";

function PrivacyPolicySections(): ReactElement {
  return (
    <div className="static-banner-sections">
      {PRIVACY_POLICY_SECTIONS.map((section) => {
        return (
          <div key={section.heading}>
            <h3 className="static-banner-heading">{section.heading}</h3>
            {section.paragraphs.map((paragraph) => {
              return <p key={paragraph} className="static-banner-copy">{paragraph}</p>;
            })}
          </div>
        );
      })}
      <h3 className="static-banner-heading">How to contact us</h3>
      <p className="static-banner-copy">
        If you have any questions about how we process your personal data, please feel free to contact us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}

export default function PrivacyPolicyBody(): ReactElement {
  return (
    <section className="disclaimer-sheet">
      <img className="disclaimer-watermark" src={disclaimerWatermark} alt="" />
      <h2 className="disclaimer-title">Privacy Policy</h2>
      <PrivacyPolicySections />
      <img className="disclaimer-dots" src={disclaimerDots} alt="dots" />
    </section>
  );
}
